export default __webpack_public_path__ + "static/media/alidaybg1.de382afc.jpeg";